import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const LazyPrivateContentModeBanner = () =>
  import(/* webpackChunkName: "4-feat-private-content-mode-banner" */ './PrivateContentModeBanner');

const LoadablePrivateContentModeBanner = lazyLoadOnRender({
  loader: LazyPrivateContentModeBanner,
});
LoadablePrivateContentModeBanner.displayName = 'PrivateContentModeBanner';

export default LoadablePrivateContentModeBanner;
